import { render, staticRenderFns } from "./DashboardOld.vue?vue&type=template&id=534832f4&scoped=true"
import script from "./DashboardOld.vue?vue&type=script&lang=js"
export * from "./DashboardOld.vue?vue&type=script&lang=js"
import style0 from "@/assets/sass/dashboard.scss?vue&type=style&index=0&id=534832f4&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534832f4",
  null
  
)

export default component.exports